import styled from 'styled-components'

export const GenerateTabContainer = styled.div`
  margin: 0 0 20px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
